<template>
    <i class="fas fa-spinner image-spin"></i>
</template>

<script>
export default {
}
</script>

<style scoped>
.image-spin {
    margin: 20px;
    text-align: center;
    display: block;
    font-size: 60px;
    color: var(--secondary-text-color);
    -webkit-animation: spin 2s linear infinite;
    -moz-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}
@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
</style>
